import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';

import { GridConnectService } from '../../grid/grid-connect.service';
import { QPointGridStickyChooserComponent } from '../../grid/grid-sticky-chooser/grid-sticky-chooser.component';
import { CommonModule } from '@angular/common';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { QPointIconModule } from '@qpoint/icons';

@Component({
    selector: 'qpoint-grid-context-bar-options',
    templateUrl: './grid-context-bar-options.component.html',
    styleUrls: ['./grid-context-bar-options.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        NgbAccordionModule,
        TranslateModule,
        QPointIconModule,
        QPointGridStickyChooserComponent
    ]
})
export class GridContextBarOptionsComponent {
  @ViewChild('exportAnchor')
  public exportAnchor: ElementRef;
  @ViewChild('chooser')
  private chooser: QPointGridStickyChooserComponent;

  @Input() title = 'common.grid.columns';

  constructor(public connectService: GridConnectService) {
  }

  toggleChooser() {
    this.chooser.toggle();
  }
}
